"use strict";

function toggleMenu(event) {
  event.stopPropagation();
  document.querySelector('.js-menu').classList.toggle('is-open');
  document.querySelector('.js-header').classList.toggle('has-menu-open');
  document.documentElement.classList.toggle("tw-overflow-hidden");

  if (document.querySelector('.js-card.is-open')) {
    document.querySelector('.js-card.is-open').classList.remove('is-open');
  }

  if (document.querySelector('.js-menu-target.is-show')) {
    document.querySelector('.js-menu-target.is-show').classList.remove('is-show');
  }
}

document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener('scroll', function (event) {
    if (window.pageYOffset > 50) {
      document.querySelector('.js-header').classList.add('is-scrolling');
    } else {
      document.querySelector('.js-header').classList.remove('is-scrolling');
    }
  });
  document.querySelector('.js-menu').addEventListener('click', function (event) {
    event.stopPropagation();
  });
  document.querySelector('.js-header').addEventListener('click', function (event) {
    event.stopPropagation();
  });
  document.body.addEventListener('click', function () {
    document.querySelector('.js-menu').classList.remove('is-open');
    document.querySelector('.js-header').classList.remove('has-menu-open');
  });
});